import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FilteredPageQuery } from 'shared';
import { UploadPhotoDTO } from '../models/upload-photo';
export const PRODUCTPROVIDER_SERVICE_IMPL = new InjectionToken<IProductProviderService>(
    'productProviderServiceImpl'
);

export interface IProductProviderService {
    getProductList(
        filteredPageQuery: FilteredPageQuery,
        loadingText: string
    ): Observable<any>;
    uploadPhoto(uploadPhotoDTO: UploadPhotoDTO): Observable<any>;
}
